import axios from "axios";
import { getFaEventLog } from "../error/faError";
import {notify} from "../../components/utils";
var instance = axios.create({
    baseURL: "https://127.0.0.1:58085",
});
instance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (response.data.pk_opErrorCode === 500) {
        window.location.reload();
    }
    if (response.data.pk_opErrorCode !== 0 && response.data.pk_opErrorCode !== 2019 && response.data.pk_opErrorCode !== 530) {
        notify(getFaEventLog(response.data.pk_opErrorCode));
    }
    return response;
}, function (error) {
    console.error(error);
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
});
/*instance.interceptors.request.use((config) => {
    if(!navigator.onLine){
        toast.error("ارتباط اینترنت شما قطع می‌باشد. لطفا از اتصال اینترنت اطمینان حاصل کنید.")
        return null;
    }
    return config;
});*/
export default instance;
